export default {"src":"/_next/static/media/Rolling-1.1s-174px.c72f54ff.svg","height":174,"width":174};